/**
 * @packageDocumentation
 * @module Sidenav
 * @category Core
 */
import { RouterLinkActive } from '@angular/router';

export type SidenavRouteFn = () => string;

/**
 * Интерфейс пункта меню
 *
 * @group Interfaces
 */
export interface SidenavItemLiteral {
  /** Заголовок пункта меню */
  name: string;
  /** Идентификатор иконки из набора Material Icons */
  icon?: string;
  /** Идентификатор зарегистрированной svg иконки */
  svgIcon?: string;
  /** Роут */
  route: string | null;
  /** Родительский пункт меню */
  parent?: SidenavItemLiteral;
  /** Дочерние пункты меню */
  subItems?: SidenavItemLiteral[];
  /** Позиция элемента в списке. */
  position: number;
  /**
   * Параметры определения активного состояния ссылки.
   */
  routerLinkActiveOptions?: RouterLinkActive['routerLinkActiveOptions'];
  /**
   * Признак заблокированного пункта меню
   */
  disabled?: boolean;

  /**
   * Субъекты права доступа.
   * Пункт меню отображается, если хотя бы к одному из субъектов пользователь имеет доступ на чтение.
   */
  subject: string[];
}

/**
 * Модель элемента бокового меню.
 *
 * @group Classes
 */
export class SidenavItem implements SidenavItemLiteral {
  name!: string;

  subject!: string[];

  icon?: string;

  svgIcon?: string;

  route!: string | null;

  parent?: SidenavItem;

  subItems?: SidenavItem[];

  position!: number;

  routerLinkActiveOptions?: RouterLinkActive['routerLinkActiveOptions'];

  disabled?: boolean;

  constructor(model?: SidenavItemLiteral) {
    if (model) {
      const { subItems, ...modelParams } = model;
      Object.assign(this, modelParams);
      this.subItems = this.mapSubItems(subItems);
    }
  }

  public hasSubItems(): boolean {
    if (this.subItems) {
      return this.subItems.length > 0;
    }

    return false;
  }

  public hasParent(): boolean {
    return !!this.parent;
  }

  public mapSubItems(list?: SidenavItemLiteral[]): SidenavItem[] | undefined {
    if (list) {
      return list.map((item) => new SidenavItem(item));
    }

    return list;
  }

  public generateLetterIcon(): string {
    const words = this.name.split(' ');

    if (words.length > 1) {
      return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toLowerCase();
    } else {
      return this.name.charAt(0).toUpperCase() + this.name.charAt(1).toLowerCase();
    }
  }
}
